/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */
import { useDispatch } from "react-redux";

import { AppDispatch } from "store";

const useAppDispatch = () => useDispatch<AppDispatch>();

export default useAppDispatch;
